export default __webpack_public_path__ + "static/social-acerca_en-9cf0fa503346fcc7e345dca692d6bf76.png";